import { Task } from 'packages/lib/api/annotations/contract/task';
import { AnnotationState } from 'packages/lib/api/annotations/contract/enums';
import { mapAnnotationStateToRole } from 'packages/task-man/service/state-machine';

// 2026-09-18 Used Gemini 3.6 Thinking for getUniqueRandomElements fn

/** Label for the annotation role queue (label / QA / review). */
export const getTaskQueueActivityLabel = (
  annotationState: AnnotationState
): string => {
  const role = mapAnnotationStateToRole(annotationState);
  switch (role) {
    case 'qa':
      return 'QA';
    case 'audit':
      return 'auditing';
    case 'flagged':
      return 'flagged review';
    case 'error':
      return 'error review';
    default:
      return 'labeling';
  }
};

export const allEqualAnnotationState = (
  tasks: Pick<Task, 'annotationState'>[]
) => tasks.every((task) => task.annotationState === tasks[0].annotationState);

export const allHaveAssignee = (
  tasks: Pick<Task, 'assignee'>[],
  assignee: string | null = null
) => tasks.every((task) => task.assignee === assignee);

export const getTaskObjectToken = (task: Pick<Task, 'tag'>): string => {
  // For legacy linked-task Scene Enrichment, the task.tag will ALWAYS be prefixed with "objectToken." for Scene Enrichment queues
  return task.tag?.substring('objectToken.'.length) ?? '';
};

export const taskHasObjectToken = (task: Pick<Task, 'tag'>): boolean => {
  return !!task.tag && task.tag.startsWith('objectToken.');
};

/** Linked-task pickup may run before `object_token` is present in the URL. */
export const resolveLinkedTaskObjectToken = (
  urlObjectToken: string | undefined,
  tasks: Task[]
): string | undefined => {
  if (urlObjectToken) return urlObjectToken;
  const [first] = tasks;
  if (first && taskHasObjectToken(first)) {
    return getTaskObjectToken(first);
  }
  return undefined;
};

export function getRandomElements<T>(array: T[], n: number): T[] {
  const items = [...array];
  const count = Math.min(Math.max(0, n), items.length);

  // Partial Fisher-Yates shuffle
  for (let i = 0; i < count; i++) {
    const j = i + Math.floor(Math.random() * (items.length - i));
    [items[i], items[j]] = [items[j], items[i]];
  }

  return items.slice(0, count);
}
